import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alert-error",
  templateUrl: "./med-icon-alert-error.component.html",
})
export class MedIconAlertErrorComponent extends SvgMixinComponent {}
